import type { EncounterState } from "./model/state";
import { statusFacetsFromInstance, type StatusRemoveStep } from "./steps";

/**
 * The status the Kraul Rifle's hit plants on its target (`mw_kraul_rifle`): "your target is impaled
 * by this weapon's harpoon-like projectile". Sourced by the attacker; ends at the end of the
 * target's next turn, at the reel-in, or when the target teleports. Named apart from the Impaler
 * Nailgun's save-ends "Impaled", which is a different rule.
 */
export const KRAUL_IMPALED_STATUS = "Kraul Impaled";

/**
 * The attacker's end of the same line, `partner` = the impaled target. It carries the reel-in
 * reaction (`Kraul Line#Reel In`), so the attacker has a row to take it from.
 */
export const KRAUL_LINE_STATUS = "Kraul Line";

/**
 * "The line snaps if your target teleports": the removals for a teleport by `moverId`, its
 * `Kraul Impaled` and every `Kraul Line` whose partner it is. Each carries the instance's facets so
 * the undo restores it exactly. Empty when the mover is on no line.
 */
export function kraulLineSnapSteps(state: EncounterState, moverId: string): StatusRemoveStep[] {
  const mover = state.combatants[moverId];
  const impaled = mover?.statuses.find((s) => s.name === KRAUL_IMPALED_STATUS);
  if (impaled === undefined) return [];
  const steps: StatusRemoveStep[] = [{ op: "status_remove", target: moverId, status: impaled.name, ...statusFacetsFromInstance(impaled) }];
  for (const id of Object.keys(state.combatants).sort()) {
    const line = state.combatants[id]!.statuses.find((s) => s.name === KRAUL_LINE_STATUS && s.partner === moverId);
    if (line !== undefined) steps.push({ op: "status_remove", target: id, status: line.name, ...statusFacetsFromInstance(line) });
  }
  return steps;
}
